/* eslint-disable react/jsx-props-no-spreading, sonarjs/cognitive-complexity */
import moment from 'moment';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { DEFAULT_SECONDARY_COLOUR } from 'shared/constants/styleConstants';
import CruiseIcon from './common/CruiseIcon';
import DayIcon from './common/DayIcon';
import LastComponent from './common/lastComponent';

export default function CruisesSection({ componentProps }) {
  const { theme } = useSelector((state) => state.ui);
  const { componentName, componentData, componentFullName, isLastComponent } =
    componentProps;
  const component = componentData[componentFullName];
  const {
    itineraryName,
    startDate,
    shipName,
    region,
    cruiseLine,
    duration,
    numberOfCabins,
    itinerary,
  } = component;

  const [isMobile, setIsMobile] = useState(window.innerWidth < 471);

  const updateMedia = () => {
    setIsMobile(window.innerWidth < 471);
  };

  useEffect(() => {
    window.addEventListener('resize', updateMedia);
    return () => window.removeEventListener('resize', updateMedia);
  });

  const mobileWidth = isMobile ? 'w-full' : 'w-1/4';
  const marginMobile = isMobile ? 'mb-0' : 'mb-[15px]';

  return (
    <div className="flex mt-[30px] xs:mt-[40px] items-start relative">
      <CruiseIcon classNames="relative z-10 hidden xs:inline" />
      <div className="xs:ml-[16px] mt-2 w-full">
        <div className="text-[22px] leading-[29.05px] font-medium flex xs:block items-center">
          <CruiseIcon
            classNames="relative z-10 inline xs:hidden"
            heightWidth="38"
          />
          <span className="ml-2.5 xs:ml-0">{componentName}</span>
        </div>
        <div className="text-[16px] leading-[31.2px] tracking-[0.25px] font-normal mt-[22px]">
          <div className="flex flex-wrap">
            {cruiseLine && (
              <div className={`${mobileWidth} mb-[20px]`}>
                <div className={`${marginMobile} text-gray-500`}>
                  Cruise line
                </div>
                <div>{cruiseLine}</div>
              </div>
            )}
            {shipName && (
              <div className={`${mobileWidth} mb-[20px]`}>
                <div className={`${marginMobile} text-gray-500`}>Ship name</div>
                <div>{shipName}</div>
              </div>
            )}
            {startDate && (
              <div className={`${mobileWidth} mb-[20px]`}>
                <div className={`${marginMobile} text-gray-500`}>
                  Embarkation date
                </div>
                <div>{moment(Number(startDate)).format('DD MMMM yyyy')}</div>
              </div>
            )}
            {duration && (
              <div className={`${mobileWidth} mb-[20px]`}>
                <div className={`${marginMobile} text-gray-500`}>Duration</div>
                <div>{duration}</div>
              </div>
            )}
            {itineraryName && (
              <div className={`${mobileWidth} mb-[20px]`}>
                <div className={`${marginMobile} text-gray-500`}>
                  Itinerary name
                </div>
                <div>{itineraryName}</div>
              </div>
            )}
            {region && (
              <div className={`${mobileWidth} mb-[20px]`}>
                <div className={`${marginMobile} text-gray-500`}>Region</div>
                <div>{region}</div>
              </div>
            )}
            {numberOfCabins && (
              <div className={`${mobileWidth} mb-[20px]`}>
                <div className={`${marginMobile} text-gray-500`}>
                  Number of Cabins
                </div>
                <div>Content</div>
              </div>
            )}
          </div>
          {itinerary &&
            itinerary.map((day, index) => (
              <div>
                <DayIcon
                  key={day.dayNumber}
                  sectionTitle={`Day ${day.dayNumber}`}
                  classNames="flex items-center"
                />
                <div
                  className={`flex items-start ${
                    index + 1 === itinerary.length ? 'dottedBorderClose' : ''
                  }`}
                  style={{
                    borderLeft: `2px dashed ${
                      theme.primaryColour || DEFAULT_SECONDARY_COLOUR
                    }`,
                    marginLeft: isMobile ? '18px' : '24px',
                  }}
                >
                  {/* <div
                    className={`border-none xs:border-l-2 xs:border-dashed xs:border-[${
                      theme.primaryColour || DEFAULT_SECONDARY_COLOUR
                    }] xs:px-2 absolute h-full xs:left-[90px] top-5 z-0`}
                    style={{
                      borderColor:
                        theme.primaryColour || DEFAULT_SECONDARY_COLOUR,
                    }}
                  /> */}
                  <CruiseIcon
                    classNames="flex-none mt-5"
                    styleObject={{ marginLeft: isMobile ? '-20px' : '-26px' }}
                    heightWidth={isMobile ? '38' : '50'}
                  />
                  <div className="flex-1 xs:ml-[16px] mt-5">
                    <div className="mt-[12px] mb-[20px] text-[22px] leading-[29.05px] font-medium">
                      {day.port}
                    </div>
                    <div>
                      Arrival time -{' '}
                      {moment(Number(day.arrivalDateTime)).format(
                        'DD MMMM YYYY HH:mm',
                      )}
                    </div>
                    <div>
                      Departure time -{' '}
                      {moment(Number(day.departureDateTime)).format(
                        'DD MMMM YYYY HH:mm',
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>

      {isLastComponent && <LastComponent />}
    </div>
  );
}
